import { inject, Injectable } from '@angular/core';
import { ApiService } from '@app/gateway';
import { PedidoModel } from '../models';
import { StoreService } from './store.service';

@Injectable({ providedIn: 'root' })
export class PedidoService {
  private readonly accountService = inject(StoreService);
  private readonly apiService = inject(ApiService);

  public async finalizarPedido(storeName: string, data: PedidoModel): Promise<any> {
    try {
      const path: string = `catalogo/${storeName}/pedidos`;
      return await this.apiService.post({ path, data });
    } catch (e: any) {
      throw new Error(e.message);
    }
  }

  public async getPedidosAPI(idCliente: number): Promise<any> {
    try {
      const storeId = this.accountService.getStoreId();
      const path: string = `catalogo/${storeId}/pedidos/${idCliente}`;
      return await this.apiService.get({ path });
    } catch (e: any) {
      throw new Error(e.message);
    }
  }

  public async getPedidos(idCliente: number): Promise<any> {
    try {
      const storeName = this.accountService.getStoreName();
      const path: string = `sync/pedidos/${storeName}/${idCliente}`;
      return await this.apiService.get({ path });
    } catch (e: any) {
      throw new Error(e.message);
    }
  }

  public async getPedidosFinalizados(idCliente: number): Promise<any> {
    try {
      const storeName = this.accountService.getStoreName();
      const path: string = `sync/pedidos/finalizados/${storeName}/${idCliente}`;
      return await this.apiService.get({ path });
    } catch (e: any) {
      throw new Error(e.message);
    }
  }
}
